"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @hidden
 */

var _Repeater =
/** @class */
function () {
  /* ---------------------------------------------------------
      CONSTRUCTORS
  --------------------------------------------------------- */
  function _Repeater(index, value) {
    this.index_ = index;
    this.value_ = value;
  }
  /* ---------------------------------------------------------
      ACCESSORS
  --------------------------------------------------------- */


  _Repeater.prototype.index = function () {
    return this.index_;
  };

  Object.defineProperty(_Repeater.prototype, "value", {
    get: function get() {
      return this.value_;
    },
    enumerable: true,
    configurable: true
  });
  /* ---------------------------------------------------------
      MOVERS & COMPARE
  --------------------------------------------------------- */

  _Repeater.prototype.next = function () {
    ++this.index_;
    return this;
  };

  _Repeater.prototype.equals = function (obj) {
    return this.index_ === obj.index_;
  };

  return _Repeater;
}();

exports._Repeater = _Repeater;